import WPButton from "./index.jsx";

export default WPButton;
